export const BUILD_VERSION = '1790904535';
